import React, { useEffect, useState } from 'react';
import {
  Card,
  CardTitle,
  CardBody,
  Button,
  Table,
  Input,
  Col,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import useVendorBranch from '../../utils/useVendorBranch';
import { toast } from 'react-toastify';

const FineMasterList = () => {
  const { user } = useSelector((state) => state.authState);
  const navigate = useNavigate();

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});
  const [list, setList] = useState([]);

  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const [filters, setFilters] = useState({
    search: '',
    isActive: '', // '', 'true', 'false' (optional)
  });

  const onHandleAdd = () => navigate('/save-fine-master');

  const onHandleEdit = (fine_master_id) => {
    const selected = list.find(
      (x) => Number(x.fine_master_id) === Number(fine_master_id)
    );
    navigate('/save-fine-master', { state: { ...(selected || {}) } });
  };

  const GetList = async () => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';
      const isActive = filters.isActive || '';
      const search = filters.search || '';

      const res = await apiService.get(
        `api/FineMaster/GetAllFineMaster?vendorId=${vendorId}&branchId=${branchId}&isActive=${isActive}&search=${encodeURIComponent(
          search
        )}`
      );

      if (res?.status === true) {
        setList(res.data || []);
      } else {
        toast.error(res?.message || 'Failed');
      }
    } catch (e) {
      console.error(e);
      toast.error('Something went wrong');
    }
  };

  const onDelete = async (fine_master_id) => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      // if (!vendorId || !branchId) {
      //   toast.error('Please select vendor & branch');
      //   return;
      // }

      const ok = window.confirm('Delete this Fine Master?');
      if (!ok) return;

      const res = await apiService.delete(
        `api/FineMaster/DeleteFineMaster?id=${fine_master_id}&vendorId=${vendorId}&branchId=${branchId}`
      );

      if (res?.status === true) {
        toast.success(res?.message || 'Deleted');
        GetList();
      } else {
        toast.error(res?.message || 'Delete failed');
      }
    } catch (e) {
      console.error(e);
      toast.error('Something went wrong');
    }
  };

  const canLoad = () =>
    conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

  useEffect(() => {
    if (canLoad()) GetList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionData.vendor_id, selectionData.branch_id]);

  useEffect(() => {
    if (canLoad()) GetList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.search, filters.isActive]);

  return (
    <>
      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Col lg='12'>
        <Card className='card-box height-100-p pd-20 mb-20'>
          {/* Header */}
          <CardTitle
            tag='h6'
            className='p-3 mb-0 d-flex align-items-center justify-content-between'
          >
            <div className='d-flex align-items-center'>
              <i className='bi bi-receipt mr-2'></i>
              Fine Master Details
            </div>

            <div className='col-3 d-flex justify-content-end'>
              <Button color='primary' size='bg' onClick={onHandleAdd}>
                <i className='bi bi-plus-circle mr-1' /> Add Fine Master
              </Button>
            </div>
          </CardTitle>

          {/* Search */}
          <div
            className='col-12 d-flex justify-content-center'
            style={{ paddingRight: '10px', paddingLeft: '10px' }}
          >
            <Input
              id='search'
              name='search'
              placeholder='Search by class name / purpose...'
              type='text'
              value={filters.search}
              onChange={(e) =>
                setFilters((p) => ({ ...p, search: e.target.value }))
              }
              className='mx-auto'
            />
          </div>

          <CardBody className=''>
            <div className='table-responsive'>
              <Table striped hover>
                <thead>
                  <tr>
                    <th style={{ width: 60 }}>#</th>
                    <th style={{ width: 90 }}>Edit</th>
                    <th style={{ width: 90 }}>Delete</th>
                    <th>Class Name</th>
                    <th>Fine Purpose</th>
                    <th style={{ width: 120 }}>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {list && list.length ? (
                    list.map((item, index) => (
                      <tr key={item.fine_master_id || index}>
                        <th scope='row'>{index + 1}</th>

                        {/* Edit */}
                        <td>
                          <Button
                            color='success'
                            size='sm'
                            onClick={() => onHandleEdit(item.fine_master_id)}
                            title='Edit'
                          >
                            <i className='bi bi-pencil'></i>
                          </Button>
                        </td>

                        {/* Delete */}
                        <td>
                          <Button
                            color='danger'
                            size='sm'
                            onClick={() => onDelete(item.fine_master_id)}
                            title='Delete'
                          >
                            <i className='bi bi-trash'></i>
                          </Button>
                        </td>

                        <td>{item.class_name ? item.class_name : 'General'}</td>
                        <td>{item.fine_purpose ? item.fine_purpose : '-'}</td>

                        <td>
                          {item.is_active ? (
                            <span className='text-success fw-bold'>Active</span>
                          ) : (
                            <span className='text-danger fw-bold'>
                              Inactive
                            </span>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} style={{ textAlign: 'center' }}>
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default FineMasterList;
